<template>
  <v-card>
    <Loader v-if="isLoading" />
    <Empty v-else-if="Object.keys(transaction).length === 0 && transaction.constructor === Object"/>
    <v-list v-else-if="!isLoading">
      <div class="listContainer">
        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">TxHash:</v-list-tile-title>
          <v-list-tile-content>
            <span>
              {{ transaction.hash }}
            <img
              class="toolbarIcons copyIcon"
              src="@/assets/img/icons/copy.png"
              alt="copy"
              v-clipboard:copy="transaction.hash"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            />
            </span>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">TxReciept Status</v-list-tile-title>
          <v-list-tile-content>{{ transaction.txStatus }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Block Height:</v-list-tile-title>
            <router-link class="router-link" :to="{ name: 'block', params: {blockNumber: transaction.blockNumber}}">
              <v-list-tile-content>{{ transaction.blockNumber }}</v-list-tile-content>
            </router-link>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Created:</v-list-tile-title>
          <v-list-tile-content v-if="transaction.timestamp">
            <span>
              <span>
                {{ transaction.timestamp | moment("utc", "from", "now") }}
              </span>
                ({{ transaction.timestamp | moment("utc", "MMM-DD-YYYY HH:mm:ss A") }} +UTC)
            </span>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">From:</v-list-tile-title>
          <router-link class="router-link" :to="{ name: 'address', params: {address: transaction.from}}">
            <v-list-tile-content>{{ transaction.from }}</v-list-tile-content>
          </router-link>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">To:</v-list-tile-title>
          <div v-if="transaction.to">
            <router-link
              class="router-link"
              v-bind:class="{'contract-addr':transaction.isContract}"
              :to="{ name: 'address', params: {address: transaction.to}}"
            >
            <v-list-tile-content>{{ transaction.to }}</v-list-tile-content>
            </router-link>
          </div>
          <div v-else-if="transaction.txType === 'Contract Creation' && transaction.contractAddress">
            Contract
                <router-link class="router-link" :to="{ name: 'address', params: {address: transaction.contractAddress}}">
                  <v-list-tile-content>{{ transaction.contractAddress }}</v-list-tile-content>
                </router-link>
            Created
          </div>
          <div v-else-if="transaction.txType">
            {{transaction.txType}}
          </div>

        </v-list-tile>

        <div v-if="transaction.tokenFrom && transaction.tokenFrom !== 'token other' ">

          <v-list-tile class="listData">
            <v-list-tile-title class="listCategory">Tokens Transfered:</v-list-tile-title>
            {{ transaction.tokenValue }}&nbsp;
            <router-link class="router-link" :to="{ name: 'token', params: {token: transaction.to, type: 'token'}}">
              <v-list-tile-content>{{ transaction.tokenSymbol }}</v-list-tile-content>
            </router-link>
          </v-list-tile>

          <v-list-tile class="listData">
            <v-list-tile-title class="listCategory">Transfered From:</v-list-tile-title>
            <router-link class="router-link" :to="{ name: 'address', params: {address: transaction.tokenFrom, type: 'address'}}">
              <v-list-tile-content>{{ transaction.tokenFrom }}</v-list-tile-content>
            </router-link>
          </v-list-tile>

          <v-list-tile class="listData">
            <v-list-tile-title class="listCategory">Transfered To:</v-list-tile-title>
            <router-link class="router-link" :to="{ name: 'address', params: {address: transaction.tokenTo, type: 'address'}}">
              <v-list-tile-content>{{ transaction.tokenTo }}</v-list-tile-content>
            </router-link>
          </v-list-tile>
        </div>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Value:</v-list-tile-title>
          <v-list-tile-content v-if="transaction.value">{{ transaction.value }} CMT</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Gas Limit:</v-list-tile-title>
          <v-list-tile-content>{{ transaction.gas }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Gas Price:</v-list-tile-title>
          <v-list-tile-content v-if="transaction.gasPrice">{{ transaction.gasPrice }} CMT</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Gas Used:</v-list-tile-title>
          <v-list-tile-content v-if="transaction.gasUsed">{{ transaction.gasUsed }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Actual Tx Cost/Fee</v-list-tile-title>
          <v-list-tile-content v-if="transaction.txResult.fee.value || transaction.txResult.fee.value == 0">{{ transaction.txResult.fee.value }} CMT</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData">
          <v-list-tile-title class="listCategory">Nonce</v-list-tile-title>
          <v-list-tile-content>{{ transaction.nonce }}</v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="listData inputData">
          <v-list-tile-title class="listCategory">Input Data
            <a v-bind:style="{display:transaction.cmtInput || !transaction.to || transaction.isContract || typeof fromHex(transaction.input) == 'boolean' ? 'none' : 'inline'}">[ <label><input type="checkbox" v-model="viewInputAsUtf8" /> View as utf-8</label> ]</a>
          </v-list-tile-title>
            <v-textarea
              v-bind:value="transaction.cmtInput ? JSON.stringify(transaction.cmtInput, null, '\t') : (!transaction.to || transaction.isContract || typeof fromHex(transaction.input) == 'boolean' || !viewInputAsUtf8 ? transaction.input : fromHex(transaction.input))"
              readonly
              full-width
              outline
              class="v-input--is-focused"
            >
            </v-textarea>
        </v-list-tile>
      </div>
    </v-list>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '../reusables/loader.vue';
import toast from '../../tools/toast';
import Empty from '../reusables/empty.vue';

export default {
  name: 'Transaction',
  data() {
    return {
      isLoading: false,
      viewInputAsUtf8: true,
    };
  },
  components: {
    Loader,
    Empty,
  },
  methods: {
    fetchData(hash) {
      this.isLoading = true;
      this.$store.dispatch('submitQuery', { query: hash, type: 'txhash' });
    },
    onCopy(e) {
      toast.copied(`${e.text.substring(0, 10)}...`);
    },
    onError() {
      this.$notify.error({
        title: 'Error',
        message: 'Failed to copy address',
        duartion: 10,
      });
    },
    fromHex(h) {
      let s = '';
      for (let i = 0; i < h.length; i += 2) {
        s += String.fromCharCode(parseInt(h.substr(i, 2), 16));
      }
      try {
        let d = decodeURIComponent(escape(s));
        return d;
      } catch (e) {
        return false;
      }
    },
  },
  watch: {
    '$route.params.txhash': function (newHash, oldHash) {
      this.fetchData(newHash);
    },
    transaction(newTransaction) {
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters(['transaction']),
  },
  created() {
    this.fetchData(this.$route.params.txhash);
  },
};
</script>
